module.exports = __webpack_public_path__ + "static/media/02-longo.4c9bdcd5.svg";